import React, { useEffect, useState } from "react";
import Logo from "../../assets/Crop2Xicon.png"
import { useTranslation } from "react-i18next";

const FarmReport = ({
  fieldName = "N/A",
  farmerName = "N/A",
  area = "N/A",
  cropName = "N/A",
  variety = "N/A",
  sowingDate = "N/A",
  deviceNo = 'N/A',
  logoBase64 = ""
}) => {
  const now = new Date().toLocaleString();
  const { t, i18n } = useTranslation();

  return (
    <div
      style={{
        background: "linear-gradient(to bottom right, #d4edda, #c3e6cb)",
        width: "100%",
        padding: "1rem",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowX: "hidden",
        overflowY: "auto",
      }}
    >
      <div
        style={{
          maxWidth: "40rem",
          margin: "0 auto",
          padding: "1.5rem",
          backgroundColor: "#fff",
          borderRadius: "0.5rem",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
      >
        {/* Header Section */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "0.5rem",
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <div
              style={{
                width: "3rem",
                height: "2rem",
                backgroundColor: "#28a745",
                borderRadius: "60%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginRight: "0.5rem",
              }}
            >
              {logoBase64 && (
                <img src={logoBase64} style={{ width: "100%", height: "100%" }} alt="Logo" />
              )}
            </div>
            <h1 style={{ fontSize: "1.5rem", fontWeight: "bold", color: "#155724" }}>
              Crop2X
            </h1>
          </div>
        </div>

        {/* Title */}
        <h2
          style={{
            textAlign: "center",
            fontSize: "1.5rem",
            fontWeight: "bold",
            marginBottom: "1.5rem",
            color: "#155724",
          }}
        >
          {t("FARM REPORT")}
        </h2>
        <p
          style={{
            textAlign: "center",
            marginBottom: "0.5rem",
            color: "#6c757d",
          }}
        >
          {t("Farm Health Report - Analysis of Crop Health and Nutritional Needs:")}
        </p>

        {/* Report Details */}
        <div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "1rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Field Name")}:</span>
            <span style={{ color: "#555" }}>{fieldName}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Farmer Name")}:</span>
            <span style={{ color: "#555" }}>{farmerName}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Planting Date:")}</span>
            <span style={{ color: "#555" }}>{sowingDate}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Crop Type:")}</span>
            <span style={{ color: "#555" }}>{cropName}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Total Area:")}</span>
            <span style={{ color: "#555" }}>{area}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}> {i18n.language === "ur" ? "مختلف قسم:" : "Variety"}</span>
            <span style={{ color: "#555" }}>{variety}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Device No:")}</span>
            <span style={{ color: "#555" }}>{deviceNo}</span>
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "0.5rem",
              justifyContent: "space-between",
            }}
          >
            <span style={{ fontWeight: "bold", marginRight: "1rem" }}>{t("Generated On:")}</span>
            <span style={{ color: "#555" }}>{now}</span>
          </div>
        </div>
      </div>
    </div>

  );
};


const FarmReportContainer = () => {
  const [reportData, setReportData] = useState({
    fieldName: "Field name not provided",
    farmerName: "Farmer name not specified",
    totalArea: "Area information not entered",
    cropName: "Crop name missing",
    variety: "Variety not mentioned",
    sowingDate: "Sowing date not recorded",
    deviceNo: "Device number not assigned",
    logoBase64: "", // Keep empty so image box stays hidden until data arrives
  });


  useEffect(() => {
    // Load base64 image
    fetch(Logo)
      .then((res) => res.blob())
      .then((blob) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          const base64data = reader.result;
          updateReportWithBase64(base64data);
        };
        reader.readAsDataURL(blob);
      });

    const updateReportWithBase64 = (base64Logo) => {
      const reportString = localStorage.getItem("report");
      let parsedData = {};
      if (reportString) {
        try {
          parsedData = JSON.parse(reportString);
        } catch (error) {
          console.error("Error parsing report data from localStorage:", error);
        }
      }

      setReportData({
        fieldName: parsedData?.fieldName || "Field name not provided",
        farmerName: parsedData?.farmerName || "Farmer name not specified",
        area: parsedData?.totalArea || "Area information not entered",
        cropName: parsedData?.cropName || "Crop name missing",
        variety: parsedData?.variety || "Variety not mentioned",
        sowingDate: parsedData?.sowingDate || "Sowing date not recorded",
        deviceNo: parsedData?.deviceNo || "Device number not assigned",
        logoBase64: base64Logo || "",
      });

    };
  }, []);


  return <FarmReport {...reportData} />;
};

export default FarmReportContainer;